











import { Component, Prop, Vue, Watch } from "vue-property-decorator";

/**
 * Image that never blocks perceived page readiness: loads async/lazy and
 * fades in once the bytes are ready (including cache hits).
 */
@Component({
  name: "FadeImage"
})
export default class FadeImage extends Vue {
  @Prop({ required: true }) private src!: string;
  @Prop({ default: "" }) private alt!: string;
  @Prop({ default: "" }) private imgClass!: string;
  @Prop({ default: true }) private lazy!: boolean;

  private loaded = false;

  get rootClass() {
    return ["fade-image", this.imgClass, { "fade-image--loaded": this.loaded }];
  }

  @Watch("src")
  onSrcChange() {
    this.loaded = false;
    this.$nextTick(() => this.checkAlreadyComplete());
  }

  mounted() {
    this.checkAlreadyComplete();
  }

  private checkAlreadyComplete() {
    const el = this.$el as HTMLImageElement | undefined;
    if (el && el.complete && el.naturalWidth > 0) {
      this.loaded = true;
    }
  }

  private onLoaded() {
    this.loaded = true;
  }
}
